module.exports = __webpack_public_path__ + "c12d92655545fd4b13e1b9b070a21744.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/lifeQuestionQ5.mp4
// module id = 414
// module chunks = 0